import classNames from 'classnames';
import BottomModal from '../BottomModal';
import { useEffect, useRef, useState } from 'react';
import PaySuccessModal from '../PaySuccessModal';
import { getParam, isIOSMiniProgram, isMiniProgram, isWechat, isWechatBrowser } from '@/pages/Mobile/utils';
import './index.scss';
import { vipOrderConfig, sVipOrderConfig } from './priceConfig';
// import { payMiniProgramPay, payWxJsApiPay } from '@/service/mobile';
import { isSupportWxPay, wxJsApiPay, wxSdkPay } from '@/pages/Mobile/utils/pay';
import { Modal } from 'antd-mobile';
import { useNavigate } from 'react-router-dom';
import useUpgrade from './useUpgrade';
import { isB } from '@/common/AOrB';
import { create_order_edit, pay_alipay as payAlipay, pay_order_query } from '@/http/api';
import { payMiniProgramPay, payWxJsApiPay, payWxPay } from '@/http/mobileApi';
import { isMobileLogin, isPhoneLogin } from '@/pages/Mobile/utils/login';


const initVipList = [
    {
        id: 13,
        title: '终身VIP',
        price: '',
        mPrice: '',
        oPrice: '',
        tag: '超值特惠',
        sTag: '惊喜钜惠',
    },
    {
        id: 12,
        title: '年VIP',
        price: '',
        mPrice: '',
        oPrice: '',
        tag: '限时3.5折',
        sTag: '限时2折',
    },
    {
        id: 11,
        title: '月VIP',
        price: '',
        mPrice: '',
        oPrice: '',
        tag: '',
        sTag: '体验首选',
    },
    {
        id: 30,
        title: '七天VIP',
        price: '',
        mPrice: '',
        oPrice: '',
        tag: '',
        sTag: '体验首选',
    },
]

const mapVipToInfo = {
    vip: {
        icon: 'https://oss.jianzeppt.com/user/573972/aa217ee8-b703-4e8a-b6a7-f04d1183c023.png',
        icon2: 'https://oss.jianzeppt.com/user/253595/07ce629c-5bb7-4714-bc0b-67eb4fb9b5b2.png',
        icon3: 'https://oss.jianzeppt.com/user/2370869/f3d1e9f6-573a-418e-8dbe-49dbbe6cafd0.png',
        icon4: 'https://oss.jianzeppt.com/user/2370869/2fb69147-f406-4872-9033-05b284425ab8.png',
        text1: '10次/月<span>PPT下载限制</span>',
        text2: '50页/月<span>AI ChatGPT生成 </span>'
    },
    svip: {
        icon: 'https://oss.jianzeppt.com/user/573972/50ec1a5f-937b-4d2a-9a5c-20f793848c33.png',
        icon2: 'https://oss.jianzeppt.com/user/2370869/8ec21a5b-a033-44b0-9097-63064127ac48.png',
        icon3: 'https://oss.jianzeppt.com/user/2370869/89a37482-b752-4048-82af-d14382aacdaf.png',
        icon4: 'https://oss.jianzeppt.com/user/2370869/1750d9ce-82b3-4ec2-a014-df70779fcb23.png',
        text1: '100次/月<span>PPT下载限制</span>',
        text2: '500页/月<span>AI ChatGPT生成 </span>'
    }
}

const PayModal = ({ visible, onSuccess, onClose, children }) => {
    const timerRef = useRef(null)
    const navigate = useNavigate()
    const [vipList, setVipList] = useState(initVipList)
    const [priceConfig, setPriceConfig] = useState(vipOrderConfig)
    // { orderId: itemData }
    const [orderDataMap, setOrderDataMap] = useState({});
    // orderConfig == priceConfig
    const [orderConfig, setOrderConfig] = useState({});
    const [selectIndex, setSelectIndex] = useState(0)
    const [payVisible, setPayVisible] = useState(false)
    const [vipType, setVipType] = useState('vip')
    const [isBind, setIsBind] = useState(false)
    // 引入升级功能
    const { isUpgrade, Deduction, isVipLift } = useUpgrade({ visible})

    useEffect(() => {
        if (visible) {
            init()
        }
    }, [visible, priceConfig, isUpgrade])

    useEffect(() => {
        const outTradeNo = localStorage.getItem('outTradeNo')
        const searchOutTradeNo = getParam('outTradeNo')
        if (outTradeNo) {
            checkPayStaus(outTradeNo)
        } else if (searchOutTradeNo) {
            checkPayStaus(searchOutTradeNo)
        }
    }, [])

    const init = async () => {
        try {
            const { orderDataMap, orderConfig } = await fetchConfig()
            setOrderConfig(orderConfig)
            setOrderDataMap(orderDataMap)
        } catch (error) {
            // toast.error("出错了，请联系管理员")
        }
    }
    const fetchConfig = async () => {
        // 用户必须登录否则创建订单的用户和发起订单的用户不是同一个人
        // 为什么要把三个不同的付费类型都发送请求创建订单？
        const dataPromiseArr = priceConfig.map((item) => {
            return create_order_edit({}, {
                abType: isB() ? 1 : 0,
                isUpgrade: isUpgrade,
                orderType: item.id,
                pptId: "-2",
            })
        });
        // 使用 Promise.allSettled 而不是 Promise.all
        const results = await Promise.allSettled(dataPromiseArr);

        const orderDataMap = new Map();
        let newOrderConfig = [];

        // 使用 results 数组而不是 dataArr
        results.forEach((result, index) => {
            if (result.status === 'fulfilled' && result.value) {
                newOrderConfig.push(priceConfig[index]);
                orderDataMap.set(priceConfig[index].id, { ...result.value });
            }
        });
        // console.log('prconfig', priceConfig)
        // 根据成功创建的订单更新 vipList
        const newVipList = newOrderConfig.map((config, index) => {
            const item = orderDataMap.get(config.id);
            let baseMonth = 12;
            if (config.id === 2) baseMonth = 1; // 假设 config.id 与 index 的对应关系
            if (config.id === 0) baseMonth = 100 * 12; // 假设 config.id 与 index 的对应关系
            const price = isUpgrade ? item.actualPrice : item.baseMoney
            return {
                ...initVipList[index],
                title: priceConfig[index].text,
                price,
                oPrice: item.originPrice,
                mPrice: (price / baseMonth).toFixed(2)
            };
        });

        setVipList(newVipList);
        return { orderDataMap, orderConfig: newOrderConfig };
    }

    const checkPayStaus = (outTradeNo) => {
        clearInterval(timerRef.current)
        const checkFn = () => {
            const payload = {
                out_trade_no: outTradeNo
            }
            pay_order_query(payload).then(res => {
                if (res.isPaid === 1) {
                    clearInterval(timerRef.current)
                    localStorage.removeItem('outTradeNo')
                    // 支付成功
                    if (isPhoneLogin()) {
                        showPaySuccessModal()
                    } else {
                        onSuccess && onSuccess()
                    }
                    // 关闭支付弹窗
                    handleClose()
                }
            }).catch(err => {
                console.log(err)
                clearInterval(timerRef.current)
                localStorage.removeItem('outTradeNo')
            })
        }
        checkFn()
        timerRef.current = setInterval(() => {
            checkFn()
        }, 1000)
    }
    const pay = async (type) => {
        const first = orderDataMap.get(orderConfig[selectIndex].id);
        let code_url;
        if (type === "wechat") {
            let data = {}
            if (isWechatBrowser()) {
                data = await payWxJsApiPay({
                    "outTradeNo": first.outTradeNo
                })
                // 拉起jsapi式微信支付
                const { prepay_id, sign, nonceStr, timeStamp, signType } = data
                wxJsApiPay({
                    data: { prepay_id, sign, nonceStr, timeStamp, signType },
                    onSuccess: () => {
                        window.location.reload()
                        console.log('支付成功！！！')
                    }
                })
            } else if (isMiniProgram()) {
                data = await payMiniProgramPay({
                    "outTradeNo": first.outTradeNo
                })
                // 拉起微信小程序支付
                const { prepay_id, sign, nonceStr, timeStamp, signType } = data
                wxSdkPay({
                    data: { prepay_id, sign, nonceStr, timeStamp, signType },
                })
            } else {
                data = await payWxPay({
                    "outTradeNo": first.outTradeNo
                })
            }


            code_url = data.code_url
        } else {
            const data = await payAlipay('', {
                "outTradeNo": first.outTradeNo
            })
            code_url = data.code_url
        }
        let url = new URL(window.location.href)
        // 添加支付成功标识
        url.searchParams.set('outTradeNo', first.outTradeNo)
        localStorage.setItem('outTradeNo', first.outTradeNo)
        // 开始轮询
        checkPayStaus(first.outTradeNo)

        // 非微信内支付
        if (!isWechat()) {
            window.location.href = code_url + (code_url.indexOf("?") !== -1 ? '&' : '?') + "redirect_url=" + window.encodeURIComponent(url)
        }
    }

    const handleClose = () => {
        onClose && onClose()
    }

    const handleClickTip = () => {
        showPaySuccessModal()
        setIsBind(true)
    }

    const handleClickVip = (type) => {
        setVipType(type)
        if (type === 'vip') {
            setPriceConfig(vipOrderConfig)
        } else if (type === 'svip') {
            setPriceConfig(sVipOrderConfig)
        }
    }

    const showPaySuccessModal = () => {
        // 非微信环境才显示弹窗
        if (!isWechat()) {
            setPayVisible(true)
        }
        // onSuccess && onSuccess()
    }

    const handleClickIOSWxApp = () => {
        handleClose()
        Modal.show({
            bodyClassName: 'ios-wxapp-modal',
            style: {
                '--z-index': 1002,
            },
            title: '提示',
            content: '点击“查看详情”，了解更多详细信息。',
            closeOnAction: true,
            actions: [
                {
                    key: 'download',
                    text: '关闭',
                    primary: true,
                },
                {
                    key: 'online',
                    text: '查看详情',
                    primary: true,
                    onClick: () => {
                        // 跳转到微信公众号文章
                        window.location.href = 'https://mp.weixin.qq.com/s?__biz=MzkxMDUwOTAyNA==&mid=2247483663&idx=1&sn=161527a21586501624c2de18f44d64d6&chksm=c12b1780f65c9e96c37dc68d02611222d851f32a8ef44295ae1a517fdda7ac14cf6f1f657854#rd'
                    }
                },
            ],
        })
    }

    const handleClickAgreement = () => {
        navigate('/mobile/agreement')
        handleClose()
    }

    const cls = classNames({
        'pay-wrap': true,
        [vipType]: true
    })

    const clsVip = classNames({
        'tab-item': true,
        'active': vipType === 'vip'
    })

    const clsSvip = classNames({
        'tab-item': true,
        'active': vipType === 'svip'
    })

    const bottomCls = classNames({
        'ios-miniprogram-wrap': isIOSMiniProgram(),
        'min-size-client': document.body.clientHeight < 700,
        'pay-wrap-modal': true,
    })
    
    return (
        <div className='pay-wrap'>
            <BottomModal className={bottomCls} visible={visible} onClose={handleClose}>
                <div className={cls}>
                    <div className="tab">
                        {
                            // !isUpgrade &&
                            <div onClick={() => handleClickVip('vip')} className={clsVip}>
                                {
                                    isUpgrade ? '升级VIP会员' : 'VIP会员'
                                }
                            </div>
                        }
                        {/* <div onClick={() => handleClickVip('svip')} className={clsSvip}>
                            {
                                isUpgrade ? '升级SVIP会员' : 'SVIP会员'
                            }
                        </div> */}
                    </div>
                    {
                        !isIOSMiniProgram() ?
                            <div className="vip-list">
                                {
                                    vipList.map((item, index) => {
                                        const { title, price, mPrice, oPrice, tag, sTag } = item
                                        const isSvip = vipType === 'svip'
                                        const cls = classNames({
                                            'vip-item': true,
                                            'active': index === selectIndex,
                                            's-active': isSvip
                                        })
                                        return <div key={index} className={cls} onClick={() => setSelectIndex(index)}>
                                            {
                                                isSvip ? sTag && <div className='tag'>{sTag}</div> : tag && <div className='tag'>{tag}</div>
                                            }
                                            <p className='title'>{title}</p>
                                            <p className='price'>¥<span>{price}</span></p>
                                            <div className="divide" />
                                            {/* <p className='m-price'>¥{mPrice}/月</p> */}
                                            <p className='o-price'>原价 ¥ {oPrice}</p>
                                        </div>
                                    })
                                }
                            </div> : <div className='skeleton'></div>
                    }
                    {!isIOSMiniProgram() && Deduction}
                    {
                        <div className="footer">
                            {
                                isIOSMiniProgram() && <div onClick={handleClickIOSWxApp} className="ios-miniprogram-btn" >
                                    解锁会员权益
                                </div>
                            }
                            {
                                isSupportWxPay() && <div onClick={() => pay('wechat')} className="wx-btn jz-resume-btn">
                                    <img src={'https://oss.jianzeppt.com/user/573972/caad3e75-b041-4416-86f8-16a477d43e50.png'} alt='wx' />
                                    微信支付
                                </div>
                            }
                            {
                                !isWechat() && <div onClick={() => pay('ali')} className="ali-btn jz-resume-btn">
                                    <img src={'https://oss.jianzeppt.com/user/573972/c362590a-82ac-4354-99e0-100d5b4e05cf.png'} alt='ali' />
                                    支付宝支付
                                </div>
                            }

                            {
                                !isWechat() && <p onClick={handleClickTip} className='tip'>我已是PC端会员，<span>绑定微信</span></p>
                            }
                            {
                                <p 
                                onClick={handleClickAgreement} 
                                className='agreement'>支付即代表您同意<span>会员协议</span></p>
                            }
                        </div>
                    }

                </div>
            </BottomModal>
            <PaySuccessModal isBind={isBind} visible={payVisible} onClose={() => setPayVisible(false)} />
        </div>
    )
}

export default PayModal;
